//Assessments modules
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"

//PrimeReact
import { classNames } from "primereact/utils"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import FormulaBuilderQuestionOptionEntry from "./FormulaBuilderQuestionOptionEntry"

export default function FormulaBuilderMultiAnswer({ options }) {
  return (
    <>
      <FormulaBuilderGroupingPanel title="Multi answer options">
        Specify how selected options should be aggregated for multi-answer
        questions.
      </FormulaBuilderGroupingPanel>

      <div
        className={classNames(
          myStyles.groupingContainer,
          myStyles.questionListContainer
        )}
      >
        {options && options.length > 0 ? (
          options.map((option) => (
            <FormulaBuilderQuestionOptionEntry
              option={option}
              key={option.id}
            />
          ))
        ) : (
          <>No question options found</>
        )}
      </div>
    </>
  )
}
